<figure #chartContainer class="m-0" [id]="'line-'+chartId"></figure>